/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./back-button.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./back-button.component";
import * as i3 from "@angular/common";
import * as i4 from "@angular/router";
var styles_BackButtonComponent = [i0.styles];
var RenderType_BackButtonComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_BackButtonComponent, data: {} });
export { RenderType_BackButtonComponent as RenderType_BackButtonComponent };
export function View_BackButtonComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "a", [["class", "btn btn-primary"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.goBack() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵted(-1, null, ["Back"]))], null, null); }
export function View_BackButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-back-button", [], null, null, null, View_BackButtonComponent_0, RenderType_BackButtonComponent)), i1.ɵdid(1, 114688, null, 0, i2.BackButtonComponent, [i3.Location, i4.Router, i4.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var BackButtonComponentNgFactory = i1.ɵccf("app-back-button", i2.BackButtonComponent, View_BackButtonComponent_Host_0, { route: "route" }, {}, []);
export { BackButtonComponentNgFactory as BackButtonComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/shared/back-button/back-button.component.ngfactory.js.pre-build-optimizer.js